import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';
import { log, getLocalStorageWithExpiry, setLocalStorageWithExpiry } from '@emyw/core-lib';
import Step3Payment from '@emyw/subscribe-lib/Step3Payment';
import { ValidateStep } from './index';
// import * as userActions from '../actions/userActions';
import { withAppContext } from '../AppContext';
import { loadUser } from '../actions/userActions';

class SelectPaymentMethod extends Component {
    state = {
        proceedTo: undefined,
    }

    componentWillMount() {
        const { context } = this.props;
        const { user } = context.state;
        ValidateStep(window.location, user).then((directTo) => {
            if (directTo !== 'payment') this.setState({ proceedTo: directTo });
        });
        context.setAppState({ currentStep: 'billing' });
        // if (user) {
        //     ValidateStep(window.location, user).then((directTo) => {
        //         if (directTo !== 'payment') this.setState({ proceedTo: directTo });
        //     });
        // } else {
        //     this.setState({ proceedTo: 'setupaccount' });
        // }
    }

    handlePaymentMethodClick = (paymentMethod) => {
        if (paymentMethod === 'card') {
            this.setState({ proceedTo: 'cardinfo' });
        } else if (paymentMethod === 'paypal') {
            this.setState({ proceedTo: 'paypal' });
        }
    };

    handlePromoCodeSubmit = (promoCode) => {
        log.trace('handlePromoCodeSubmit', promoCode);
        if (promoCode) setLocalStorageWithExpiry('enjoy-promo-code', promoCode, 604800000);
    }

    handleValidatedPromoCode = ({ code, activationMessage, codeEntryWindowDays }) => {
        if (code) {
            setLocalStorageWithExpiry('enjoy-promo-code', code, 604800000);
            log.trace(activationMessage, codeEntryWindowDays);
        }
    }

    handleInvalidPromoCode = ({ message }) => {
        log.trace(message);
    }

    handleChangePlanClick = () => {
        this.setState({ proceedTo: 'plan' });
    }

    render() {
        const { proceedTo } = this.state;
        const { context } = this.props;
        const { user, skipPlanSelect } = context.state;
        // log.trace('payment state user:', user);
        if (proceedTo) return <Redirect push to={`/signup/${proceedTo}`} />;
        return (
            <div style={{ margin: '0 auto', maxWidth: '500px' }}>
                <Helmet>
                    <title>Enjoy Signup - Payment Method</title>
                    <meta name="description" content="Select payment method" />
                </Helmet>
                {user && (
                    <Step3Payment
                        onPaymentMethodClick={this.handlePaymentMethodClick}
                        user={user}
                        onValidatedPromoCode={this.handleValidatedPromoCode}
                        onInvalidPromoCode={this.handleInvalidPromoCode}
                        defaultPromoCode={getLocalStorageWithExpiry('enjoy-promo-code')}
                        onChangePlanClick={this.handleChangePlanClick}
                        planSelectDisabled={skipPlanSelect}
                        loadUser={loadUser}
                        context={context}
                        darkMode
                    />
                )}
            </div>
        );
    }
}

// const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(userActions, dispatch) });

// const mapStateToProps = state => ({ user: state.user });

// export default connect(mapStateToProps, mapDispatchToProps)(SelectPaymentMethod);
export default withAppContext(SelectPaymentMethod);
